import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/about.jpg" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Acerca de Nosotros</h2>
              <p className="whitespace-pre-line">{props.data ? props.data.paragraph : "loading..."}</p>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                <h3>Visión</h3>
                  <p style={{ margin: "0 0" }}>
                  Ofrecer soluciones innovadoras en Tecnologías de la Información,
                  Comunic
                  </p>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                <h3>Misión</h3>
                  <p style={{ margin: "0 0" }}>
                  Ser la mejor opción efectiva y confiable, brindando un buen servicio y
                  resolviendo las necesidades de cada uno de nuestros clientes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
